import React from 'react'

const SvgFileVisualizationOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.03 2c.422 0 .753.066.995.197.207.089.48.305.821.648l.15.155 4.007 4.006c.46.406.742.765.847 1.076.075.222.122.45.14.684l.01.237v.908c-.501-.489-.93-.837-1.289-1.045-.537-.312-.801-.48-1.6-.744l-.074-.02h.066l-.103-.1-3-3v2.864l-.025.003s-.344.036-.92.207l-.15.046c-.666.21-.85.33-.85.33l-.042-.344L11 8.003v-4H5l.002 16h4.099c.493.45.933.788 1.321 1.013 1.086.63 1.91.82 2.896.954l.25.033H5.003c-.71-.006-1.223-.184-1.539-.535-.28-.312-.434-.732-.46-1.262L3 20.003v-16c.006-.699.181-1.21.525-1.534.31-.292.774-.448 1.39-.467l.212-.001h6.903zM14 10a5 5 0 014.178 7.747l2.578 2.588c.393.447.243 1.013-.087 1.342-.33.328-.896.469-1.316.054l-2.484-2.48-.092-.092A5 5 0 1114 10zm0 2a3 3 0 100 6 3 3 0 000-6zM9 8.002c.667 0 1 .333 1 1 0 .62-.287.95-.862.995L9 10.002H8c-.667 0-1-.333-1-1 0-.619.288-.95.863-.995l.138-.005H9z'
    />
  </svg>
)

export default SvgFileVisualizationOutline
